import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import MuiButtonGroup from '@mui/material/ButtonGroup';
import React, { forwardRef } from 'react';
import { Button } from '../button';
import { IconArrowDropDown } from '../icon';
import { Menu } from '../menu';
import { styled } from '../styled';
export * from './summary-button-row';
export const ButtonGroup = forwardRef((props, ref) => {
    return _jsx(MuiButtonGroup, { ref: ref, ...props });
});
const ButtonNoWrap = styled(Button)({
    whiteSpace: 'nowrap'
});
export const ButtonGroupSplit = (props) => {
    const { spacing } = useTheme();
    const { item, actions, size = 'medium', ...buttonGroupProps } = props;
    const anchorRef = React.useRef(null);
    const [action] = actions;
    return (_jsxs(ButtonGroup, { ref: anchorRef, variant: "contained", disableElevation: true, ...buttonGroupProps, children: [_jsx(ButtonNoWrap, { size: size, onClick: () => action?.onClick?.(action.item), children: action?.primary }), _jsx(Menu, { anchorRef: anchorRef, item: item, actions: actions.map((action) => ({
                    ...(action?.avatar && {
                        avatar: {
                            ...action.avatar,
                            size: 40,
                            color: 'action.selected',
                            variant: 'rounded'
                        }
                    }),
                    iconProps: { color: 'primary' },
                    type: 'ListItem',
                    ...action
                })), anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }, transformOrigin: {
                    horizontal: 'right',
                    vertical: parseInt(spacing(-0.5), 10)
                }, children: _jsx(Button, { size: size, children: _jsx(IconArrowDropDown, { color: "inherit" }) }) })] }));
};
